import type { TranslationDict } from '../en';

const sv: TranslationDict = {
  'header.buy': 'Köp',
  'header.sell': 'Sälj',
  'spend.label': 'Du betalar',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Du får',
  'payment.label': 'Betalningsmetod',
  'payment.select': 'Välj',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Inga betalningsmetoder tillgängliga för detta par',
  'wallet.label': 'Mottagande plånboksadress',
  'wallet.placeholderBuy': 'Ange din mottagningsadress',
  'wallet.placeholderSell': 'Ange din avsändningsadress',
  'wallet.validating': 'Validerar adress...',
  'wallet.invalid': 'Ange en giltig plånboksadress',
  'wallet.invalidServer': 'Ogiltig plånboksadress',
  'cta.buy': 'Köp {crypto}',
  'cta.sell': 'Sälj {crypto}',
  'cta.gettingPrice': 'Hämtar bästa pris...',
  'cta.processing': 'Bearbetar...',
  'footer.poweredBy': 'Drivs av ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Kursuppdelning',
  'rate.close': 'Stäng',
  'rate.updatesIn': 'Kursen uppdateras om 00:{seconds}',
  'rate.noQuote': 'Inget prisförslag tillgängligt',
  'rate.exchangeRate': 'Växelkurs',
  'rate.processingFee': 'Handläggningsavgift',
  'rate.networkFee': 'Nätverksavgift',
  'rate.provider': 'Leverantör',
  'toast.orderCreated': 'Order skapad',
  'toast.redirecting': 'Omdirigerar till kassan...',
  'toast.orderFailed': 'Order misslyckades',
  'toast.couldNotCreate': 'Kunde inte skapa order',
  'toast.quoteError': 'Prisförslag misslyckades',
  'toast.noProviders': 'Inga leverantörer',
  'toast.somethingWrong': 'Något gick fel',
  'error.amountZero': 'Beloppet måste vara mer än 0',
  'error.minAmountFiat': 'Minimibelopp är {min} {currency}',
  'error.minAmountCrypto': 'Minimibelopp är {min} {currency}',
  'error.noProviders': 'Inga leverantörer tillgängliga för denna kombination',
  'error.currencyUnavailableBuy': 'Denna valuta är inte tillgänglig för köporder',
  'error.currencyUnavailableSell': 'Denna valuta är inte tillgänglig för säljorder',
  'parity.info': 'Du debiteras för {receiveAmount} {crypto}, resten upp till {spendAmount} {fiat} krediteras ditt {partner}-konto',
  'redirect.secureBadge': 'Säker betalning',
  'redirect.title': 'Fortsätt betalning',
  'redirect.description': 'Du omdirigeras till {gateway} för att slutföra din betalning.',
  'redirect.countdown': 'Omdirigerar om {seconds}...',
  'redirect.openTab': 'Öppna ACH i ny flik',
  'redirect.cancel': 'Avbryt',
  'checkout.noOrder': 'Ingen order hittades',
  'checkout.goBack': 'Gå tillbaka',
  'checkout.expired': 'Kassan har gått ut',
  'checkout.expiredDesc': 'Sessionen har gått ut. Försök igen.',
  'checkout.startOver': 'Börja om',
  'checkout.cancel': 'Avbryt',
  'checkout.loading': 'Laddar kassan...',
  'checkout.iframeTitle': 'Leverantörens kassa',
  'checkout.widgetTitle': 'Betalningskassa',
  'checkout.unknownMethod': 'Okänd betalningsmetod',
  'processing.default': 'Bearbetar din order...',
  'processing.pending': 'Väntar på betalningsbekräftelse...',
  'processing.active': 'Bearbetar din transaktion...',
  'processing.generic': 'Bearbetar...',
  'processing.checkingStatus': 'Kontrollerar status...',
  'processing.orderId': 'Order-ID',
  'processing.provider': 'Leverantör',
  'processing.amount': 'Belopp',
  'processing.receiving': 'Mottagning',
  'processing.network': 'Nätverk',
  'processing.toAddress': 'Till adress',
  'processing.usuallyMinutes': 'Detta brukar ta några minuter.',
  'processing.safeToClose': 'Du kan tryggt stänga den här sidan — vi skickar ett e-postmeddelande när det är klart.',
  'complete.buyTitle': 'Köp genomfört!',
  'complete.sellTitle': 'Försäljning genomförd!',
  'complete.buyDesc': 'Ditt {crypto} har skickats till din plånbok.',
  'complete.sellDesc': 'Din {fiat}-utbetalning bearbetas.',
  'complete.amountBuy': 'Mottaget belopp',
  'complete.amountSell': 'Sålt belopp',
  'complete.paidBuy': 'Betalt belopp',
  'complete.paidSell': 'Utbetalningsbelopp',
  'complete.network': 'Nätverk',
  'complete.wallet': 'Plånbok',
  'complete.transaction': 'Transaktion',
  'complete.provider': 'Leverantör',
  'complete.orderId': 'Order-ID',
  'complete.completed': 'Genomförd',
  'complete.viewExplorer': 'Visa i Explorer',
  'complete.done': 'Klar',
  'errorStep.failed': 'Betalning misslyckades',
  'errorStep.cancelled': 'Order avbruten',
  'errorStep.expired': 'Order har gått ut',
  'errorStep.refunded': 'Order återbetald',
  'errorStep.unknown': 'Något gick fel',
  'errorStep.failedBuy': 'Din betalning kunde inte behandlas. Försök igen eller använd en annan betalningsmetod.',
  'errorStep.failedSell': 'Din försäljning kunde inte behandlas. Försök igen.',
  'errorStep.cancelledBuy': 'Din order avbröts. Ingen betalning behandlades.',
  'errorStep.cancelledSell': 'Din försäljning avbröts. Ingen krypto överfördes.',
  'errorStep.expiredBuy': 'Din order har gått ut. Påbörja ett nytt köp.',
  'errorStep.expiredSell': 'Din order har gått ut. Påbörja en ny försäljning.',
  'errorStep.refundedBuy': 'Din betalning har återbetalats. Pengarna bör synas på ditt konto inom 5–10 arbetsdagar.',
  'errorStep.refundedSell': 'Ditt krypto har returnerats. Pengarna bör snart synas i din plånbok.',
  'errorStep.genericDesc': 'Ett oväntat fel uppstod. Försök igen.',
  'errorStep.orderId': 'Order-ID',
  'errorStep.tryAgain': 'Försök igen',
  'errorStep.startOver': 'Börja om',
  'errorStep.return': 'Tillbaka',
  'errorStep.needHelp': 'Behöver du hjälp? Kontakta ',
  'errorStep.reference': 'Referens: {orderId}',
  'confirm.buyTitle': 'Bekräfta köp',
  'confirm.sellTitle': 'Bekräfta försäljning',
  'confirm.loading': 'Laddar...',
  'confirm.provider': 'Leverantör',
  'confirm.youPay': 'Du betalar',
  'confirm.youSell': 'Du säljer',
  'confirm.youReceive': 'Du får',
  'confirm.wallet': 'Plånbok',
  'confirm.network': 'Nätverk',
  'confirm.refundAddress': 'Återbetalningsadress',
  'confirm.parityNote': 'Det debiterade beloppet från leverantören kan skilja sig. Resten upp till {amount} {crypto} krediteras ditt {partner}-konto.',
  'confirm.processing': 'Bearbetar...',
  'confirm.confirmPay': 'Bekräfta och betala',
  'confirm.confirmSell': 'Bekräfta och sälj',
  'confirm.payout': '{currency}-utbetalning',
  'modal.selectFiat': 'Välj fiatvaluta',
  'modal.selectCrypto': 'Välj kryptovaluta',
  'modal.choosePayment': 'Välj betalningsmetod',
  'modal.selectCountry': 'Välj ditt land',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Populärt',
  'modal.recommended': 'Rekommenderat',
  'modal.noCurrencies': 'Inga valutor hittades',
  'modal.noPaymentMethods': 'Inga betalningsmetoder hittades',
  'modal.noCountries': 'Inga länder hittades',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Plats',
  'settings.darkMode': 'Mörkt läge',
  'settings.privacy': 'Integritetspolicy',
  'settings.terms': 'Användarvillkor',
  'settings.language': 'Språk',
  // ─── Additional ───
  'modal.chooseRamp': 'Välj Ramp',
  'modal.bestPrice': 'Bästa pris',
  'modal.noQuotes': 'Inga prisförslag tillgängliga för denna förfrågan',
  'modal.noProvidersFound': 'Inga leverantörer hittades',
  'payment.unavailableFor': 'Inga betalningsmetoder tillgängliga för {currency}',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Det gick inte att skapa order',
  'errorStep.returnToMerchant': 'Återgå till handlaren',
  'confirm.cryptoOnNetwork': '{crypto} på {network}',
  'payment.name.card': 'Kort',
  'payment.name.bankTransfer': 'Banköverföring',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default sv;
